import { createKernel } from "@ex0/kernel";
import { createDesktopRenderer } from "@ex0/windows/dom";
import "@ex0/windows/css/windows.css";
import "@ex0/menu/css/menu.css";
import "@ex0/icon-grid/css/icon-grid.css";
import "./main.scss";
import clock from "@ex0/app-clock";
import desktopApp from "@ex0/app-desktop";
import imageViewer from "@ex0/app-image-viewer";
import terminal from "@ex0/app-terminal";
import v86 from "@ex0/app-v86";
import { createBrowserFileSystem } from "./fs";
import { createMenubar } from "./menubar";

async function boot() {
  const root = document.getElementById("root")!;
  root.style.cssText =
    "display:flex;flex-direction:column;height:100vh;width:100vw;";

  createMenubar(root);

  const desktop = document.createElement("div");
  desktop.style.cssText = "flex:1;position:relative;overflow:hidden;";
  root.appendChild(desktop);

  const fs = await createBrowserFileSystem();

  const kernel = createKernel({
    bounds: () => ({
      width: desktop.clientWidth,
      height: desktop.clientHeight,
    }),
    fs,
  });

  kernel.install(terminal);
  kernel.install(clock);
  kernel.install(imageViewer);
  kernel.install(v86);
  kernel.install(desktopApp);

  const desktopPid = kernel.spawn("desktop");
  kernel.mountWindowlessProcess(desktopPid, desktop);

  createDesktopRenderer({
    manager: kernel.windowManager,
    root: desktop,
    onRequestClose: (wid) => kernel.requestClose(wid),
    onMount: (wid, container) => kernel.mountProcess(wid, container),
  });

  kernel.spawn("terminal");
}

boot().catch(console.error);
